import { render } from "./RegistrationCompensationTableComponent.vue?vue&type=template&id=1016163c&scoped=true"
import script from "./RegistrationCompensationTableComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationCompensationTableComponent.vue?vue&type=script&lang=js"

import "./RegistrationCompensationTableComponent.vue?vue&type=style&index=0&id=1016163c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1016163c"]])

export default __exports__